var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      staticClass: "row d-flex flex-row",
      attrs: {
        "confirm-loading": _vm.confirmLoading,
        title: _vm.$t("wp.typeInANumberDesc"),
        visible: _vm.localVisibleStartChat,
      },
      on: {
        cancel: _vm.handleCancel,
        ok: function ($event) {
          return _vm.handleOk(_vm.wpContactNumber)
        },
      },
    },
    [
      _vm.showAlertMessage
        ? _c(
            "div",
            { staticClass: "pb-3" },
            [
              _c("a-alert", {
                attrs: {
                  message: _vm.$t("wp.toLittleChar"),
                  type: "error",
                  banner: "",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "d-flex flex-row align-items-center justify-content-center",
        },
        [
          _c("vue-country-code", {
            staticClass: "col-3 country-code",
            attrs: {
              defaultCountry: _vm.userLastCountry,
              enabledCountryCode: true,
            },
            on: {
              onSelect: function ($event) {
                return _vm.onSelect($event)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-8" },
            [
              _c("a-input", {
                attrs: {
                  placeholder: _vm.$t("message.phone"),
                  autocomplete: "off",
                  trim: "",
                  type: "text",
                },
                model: {
                  value: _vm.wpContactNumber,
                  callback: function ($$v) {
                    _vm.wpContactNumber = $$v
                  },
                  expression: "wpContactNumber",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }